import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-responsive-modal";
import medpassService from "../services/emar-medpass-service";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import { selectUsers } from "../state/reducers/userSlice";
import { updateSelectedPatient } from "../state/reducers/emarSlice";
import NO_PATIENTS from "../assets/img/no-patients.png";
import React, { useState, useEffect, useRef, createRef } from "react";
import moment from "moment";
import { Multiselect } from "multiselect-react-dropdown";
import Select from 'react-dropdown-select';

const KOPAdministration = ({ history }) => {
  const multiselectRef = createRef();
  const { user } = useSelector(selectUsers);
  const dispatchEmar = useDispatch();
  const [completed, setCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [patients, setPatients] = useState([]);
  const [totalPatients, setTotalPatients] = useState([]);
  const [patData, setPatData] = useState({});
  const [medications, setMedications] = useState([]);
  const [search, setSearch] = useState("");
  const [rxcode, setRxcode] = useState("");
  const [openMedicationPopup, setOpenMedicationPopup] = useState(false);
  const didMount = useRef(false);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const inputRef = useRef(null);
  const [inputValues, setInputValues] = useState({});
  const [activeStatMeds, setActiveStatMeds] = useState([]);
  const getPatientStatMeds = async (patId) => {
    try {
      let resp = await medpassService.getEmarPatientMedStats( moment(date).format("MM/DD/YYYY"),patId, user?.facility );
      setActiveStatMeds(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const CheckReAdministerStatus = async (id, i) => {
    try {
      let resp = await medpassService.CheckKOPReAdministerStatus(id);
      if (resp?.is_re_administrable === 'T') {
        const updatedMedications = medications;
        updatedMedications[i].is_readministration = true;
        updatedMedications[i].ori_kop_date = updatedMedications[i].kop_date;
        updatedMedications[i].ori_kop_end_date = updatedMedications[i].kop_end_date ;
        updatedMedications[i].ori_dose_taken_qty =  updatedMedications[i].dose_taken_qty 
        updatedMedications[i].kop_date = moment(date).format("MM/DD/YYYY");
        updatedMedications[i].kop_end_date = '';
        updatedMedications[i].dose_taken_qty = Number(inputValues[updatedMedications[i].rxf_id]);
        setDisableSubmit(false);
        doKOPQtyValidation(updatedMedications[i]?.fil_id, inputValues[updatedMedications[i].rxf_id], i)
        setMedications([...updatedMedications]);

      } else {
        const updatedMedications = medications;
        updatedMedications[i].is_readministration = false;
        setMedications([]);
        setMedications([...updatedMedications]);
        const { hide } = cogoToast.error(
          "This medication cannot be re-administered",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const onCloseMedicationModal = async () => {
    setOpenMedicationPopup(false);
    setPatData({});
    setMedications([]);
    // document.getElementById("patSearch").focus();
    setDisableSubmit(true);
    setSearchValue('');
  };
  const [limit, setLimit] = useState(50);
  const [nextUrl, setNextUrl] = useState('');
  function debounce(func, wait) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, arguments);
      }, wait);
    };
  }
  const [isAtBottom, setIsAtBottom] = useState(false);
  const handleKOPScroll = () => {
    if(window.scrollY +window.innerHeight >= document.body.scrollHeight){
          setIsAtBottom(true);
    }else{
      setIsAtBottom(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', debounce(handleKOPScroll,1000));
    return () => window.removeEventListener('scroll', handleKOPScroll);
  }, [loading]);
  useEffect(() => {
    getDrugList(user?.facility);
    getDefaultSettings();
  }, [user?.facility]);
  // useEffect(() => {
  //   if (isAtBottom && nextUrl) {
  //     getPatients(nextUrl, true);
  //   }
  // }, [isAtBottom]);

  const formQuery = (date, search,completed,limit) => {
    var query = "";
    if (date) {
      query += "date=" + moment(date).format("MM/DD/YYYY")
    }
    if (search) {
      query += "&search=" + search?.replace(/^0+/, '')
    }
    query += "&isComplete=" + completed
    query += "&fac_id=" +  user?.facility
    query += "&limit=" + limit ;
    return query;
  }
  const handleScanRX = async (e) => {
    if (e.key === "Enter" && rxcode !== "") {
      const rowIndex = medications?.find(item => item?.rx_number === Number(rxcode));
      rowIndex.status = user?.userRole === "EMAR_USER" ? 'S' : 'A';
      setMedications([...medications]);
      setRxcode("");
    }

  }
  const getPatients = async (query,append) => {
    try {
      setLoading(true);
      const resp = await medpassService.getKOPPatients(query);
      if(!nextUrl){
        document.getElementById("patSearch").focus();
      }
      setNextUrl(resp?.nextUrl?.split('?')[1])
      if (append) {
        let total = [...totalPatients, ...resp?.response]
        setPatients(total);
        setTotalPatients(total);
      } else {
        setPatients(resp?.response);
        setTotalPatients(resp?.response);
      }
      if (search && resp?.response?.length === 1 && !completed) {
        setPatData(resp?.response?.[0]);
        getMedications(resp?.response?.[0].pat_id);
      }
      setIsAtBottom(false);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting patients. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  // useEffect(() => {
  //   if (didMount.current) {
  //   const getKOPData = setTimeout(() => {
  //     setNextUrl("");
  //     let query = formQuery(date, search, completed,limit);
  //     if(!completed){
  //       getPatients(query, false);
  //     }
  //   }, 500)
  //   return () => clearTimeout(getKOPData)
  // } else {
  //   didMount.current = true;
  // }
  // }, [search])
  const getMedications = async (patId) => {
    try {
      const resp = await medpassService.getKOPPatientMedications(
        moment(date).format("MM/DD/YYYY"),
        patId,
        user?.facility);
      setMedications(resp);
      setInitialValues(resp);
      getPatientStatMeds(patId);
      setOpenMedicationPopup(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting patient medication. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [drgName, setDrugName] = useState([]);
  const [drgList, setDrugList] = useState([]);
  const [totalDrgList, setTotalDrugList] = useState([]);
  const [error, setError] = useState(false);
  const getDrugList = async (fac_id) => {
    try {
      let response = await medpassService.getDrugs(fac_id);
      response.sort((a, b) => {
        const nameA = a.drg_name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.drg_name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      
        // names must be equal
        return 0;
      });
      setDrugList([]);
      setDrugList(response);
      setTotalDrugList([]);
      setTotalDrugList(response); 
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving drugs. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
};
  const handleStatMedsSubmit = async () => {
    try {
      if (Number(amount) === 0 || amount === '' || drgName?.length === 0) {
        setError(true);
        return;
      }

      const params = {
        "range_id": range,
        "med_date": moment(date).format("MM/DD/YYYY"),
        "pat_id": patData?.pat_id,
        "drg_id": drgName[0].drg_id,
        "status": 'P',
        "dose_taken_qty": amount
      }
      await medpassService.submitMedication({"medPassAdminModels": [params]});
      const { hide } = cogoToast.success("Request submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      getMedications(patData?.pat_id);
      onStatMedpassCloseModal();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [amount, setAmount] = useState('');
  const [statMedpassOpen, setStatMedpassOpen] = useState(false);
  const onStatMedpassCloseModal = () => {
    setStatMedpassOpen(false);
    setError(false);
    setAmount('');
    setDrugName([]);
    setRange('');
  };
  const doKOPQtyValidation = async (fil_id, qty, i) => {
    try {
      if(!fil_id || qty === "null"){
        return
      }
      const resp = await medpassService.postKOPQtyValidation(
        fil_id,
        qty);
        if(!resp?.isValid){
          const updatedMedications = medications;
          updatedMedications[i].koperror = true;
          setMedications([]);
          setMedications([...updatedMedications]);
        
        }else {
          const updatedMedications = medications;
          updatedMedications[i].days_supply = resp?.days_given;
          updatedMedications[i].kop_range_ids = resp?.range_ids;
          updatedMedications[i].koperror = false;
          setMedications([]);
          setMedications([...updatedMedications]);
        }
     
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error validating kop quantity. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const setInitialValues = (allMedications) => {
    const initialValues = {};
    const updatedMedications = allMedications.map(item => {
      if (
        item.status === 'K' &&
        Number(item?.today_admit_qty) < Number(item?.dly_qty) &&
        Number(item?.qty_dsp) > 0
      ) {
        return { ...item, kop_date: '' };
      }
      return item;
    });

    setMedications(updatedMedications);

    updatedMedications.forEach(item => {
      const doseTaken = item.status === 'K'
        ? Number(item.last_admit_qty) > 0
          ? Number(item.last_admit_qty)
          : item.qty_dsp
        : item.qty_dsp;
      initialValues[item.rxf_id] = String(doseTaken);
    });
    setInputValues(initialValues);
  }
  const handleMedicationSubmit = async () => {
    try {
      setDisableSubmit(false);
      if( document.getElementsByClassName('error').length > 0){
        const { hide } = cogoToast.error(
          "There are one or more errors. Please fix the errors before submitting.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        return ;
      }
      let kopqtyerror = false;
      medications.forEach((item,i ) => {
       if(item?.kop_date !== ''&& item.dose_taken_qty === 'null'){
        const { hide } = cogoToast.error(
          "Please provide quantity",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        kopqtyerror = true;
       } 
      })
      if(kopqtyerror){
          return;
      }
      var medicationsList = [];

      medications.forEach(item => {
        item.range_ids.forEach(ele => {
          var med = { ...item };
          med.range_id = ele;
          medicationsList.push(med);
        })

      })

      await medpassService.submitKOPMedication(medicationsList);

      setOpenMedicationPopup(false);
      setPatData({});
      setMedications([]);
      // setNextUrl("");
      // if(search?.length > 0){
      //   setSearch("");
      // }else{
      //   let query = formQuery(date, search, completed,limit);
      //   getPatients(query, false);
      // }
      onCloseMedicationModal();
      const { hide } = cogoToast.success("Request submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });

    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleNavigationToHistory = async (item) => {
    try {
      dispatchEmar(updateSelectedPatient(item));
      await history.push("/medhistory");
    } catch (e) {
      setLoading(false);
    }
  };
  const handleDeleteMedsGivenToday = async (id, patId) => {
    try {
      setLoading(true);
      await medpassService.deleteMedsGivenToday(id);
      const { hide } = cogoToast.success("Stat Med deleted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      let patientMedStatsResp = await medpassService.getEmarPatientMedStats( moment(date).format("MM/DD/YYYY"),patId, user?.facility );
      setActiveStatMeds(patientMedStatsResp);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting Stat Medication. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   setNextUrl("");
  //   let query = formQuery(date, search, completed,limit);
  //   getPatients(query, false);
  // }, [date, user?.facility, completed]);

  const handleInputChange = (e, i, rxf_id) => {
    let obj = inputValues;
    obj[rxf_id] = Number( e.target.value)
    setInputValues(obj)
    const updatedMedications = medications;
    updatedMedications[i].dose_taken_qty = Number(e.target.value);
    setMedications([]);
    setMedications([...updatedMedications]);
    if( Number( e.target.value) >= 0) {
      doKOPQtyValidation( updatedMedications[i].fil_id, Number(e.target.value), i);
    }
  }
  const [searchValue, setSearchValue] = useState('');
  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);

    return debouncedValue;
  };
  const debouncedSearchQuery = useDebounce(searchValue, 500); // Delay of 500ms

  useEffect(() => {
    if (debouncedSearchQuery)
      getPatientsBySearch(debouncedSearchQuery);
  }, [debouncedSearchQuery]);

  const getPatientsBySearch = async (search) => {
    try {
      setPatients([])
      setLoading(true);
      let query = formQueryForSearch(search);
      const resp = await medpassService.getKOPPatientsBySearch(query); 
      setPatients([...resp]);  
      setLoading(false);
    } catch (e) {
      console.log("e ::: ", e);
      
      const { hide } = cogoToast.error(
        "Error getting patients. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  const [rangeList, setRangeList] = useState([]);
  const [range, setRange] = useState('');
  const getDefaultSettings = async () => {
    try {
      const resp = await medpassService.getDefaults(user?.facility);
      setRangeList(resp?.ranges);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const formQueryForSearch = (search) => {
    var query = "";
    if (search) {
      query += "search=" + search?.replace(/^0+/, '')
    }
    query += "&fac_id=" +  user?.facility
    return query;
  }

  return (
    <>
      <CipHeader />
      <Modal open={statMedpassOpen} onClose={onStatMedpassCloseModal} center styles={{ modal: { height: "500px", "overflowY": "visible" , "width": "650px"} }}>
        <div className="pt-6 px-8 pb-12 ">
          <h3
            className="text-2xl leading-6 font-medium  font-bold "
            id="medication-headline"
          >
            STAT MEDS
          </h3>
          <div className="bg-white mt-4 rounded ">
            <div className="p-2 text-xs">
              <ul>
              <li className="inline-block text-xs leading-6 w-full mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Range
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                *
              </span>
              <select
                name="range"
                aria-label="Select Range"
                value={range}
                onChange={(e) => setRange(e.target.value)}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Range</option>
                {rangeList
                  ? rangeList.map((pass, i) => {
                    return (
                      <option key={pass.id} value={pass.id}>
                        {pass.title}
                      </option>
                    );
                  })
                  : null}
              </select>
              {error && range?.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You need to specify range
                </p>
              )}
            </li>

                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Drug name
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                 
                  {drgList ? (
                    <Select
                      name="drgList"
                      options={drgList}
                      labelField="drg_name"
                      values={drgName}
                      valueField="id"
                      multi={false}
                      searchable={true}
                      onChange={(selectedList) => {
                        setDrugName(selectedList);
                      }}
                      onClearAll={() => {
                        setDrugName([]);
                      }}
                      searchFn={(val) => {
                        if (val.state.search){
                          return drgList.filter((item) => {
                            return item.drg_name.toUpperCase().startsWith(val.state.search.toUpperCase())
                        })
                        }else{
                          return drgList
                        }
                      }}
                    />
                  ) : (
                    ""
                  )}

                  {error && drgName?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You need to specify drug name
                    </p>
                  )}
                </li>
                {drgName?.length !== 0 && <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-6">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Quantity
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">
                    *
                  </span>
                  <input
                    id="amount"
                    name="amount"
                    type="number"
                    value={amount}
                    placeholder="Enter"
                    onChange={(e) => {
                      setAmount(e.target.value)
                    }
                    }
                    className={` border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                  {error &&( Number(amount) === 0  || amount === '')&& (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You need to specify the quantity administered
                    </p>
                  )}
                </li>}
              </ul>
            </div>
          </div>

          <div className="flex justify-center mt-3">
            <button
              onClick={() => {
                onStatMedpassCloseModal();
              }}
              type="button"
              className="mr-3 rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleStatMedsSubmit();
              }}
              type="button"
              className=" rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Submit
            </button>


          </div>
        </div>
      </Modal>

      <Modal
        styles={{
          modal: { maxWidth: "1300px", minWidth: "1100px", overflowX: "hidden" },
        }}
        open={openMedicationPopup}
        onClose={onCloseMedicationModal}
      >
        <div className="pt-4 px-4 pb-4 ">
          <div className="flex flex-row w-full">
            <div className="">
              <img
                className="rounded-full w-28 h-28"
                alt=""
                src={patData?.profile_pic}
              />
            </div>
            <div className="w-4/5 ml-3 ">
              <div className="inline-flex">
                <div className="flex">
                  <h3
                    className="text-2xl leading-6 font-medium  font-bold "
                    id="medication-headline"
                  >
                    Administer Medication
                  </h3>
                </div>
                <div className="pl-3">
                  {medications?.[0]?.allergies && <div className="text-base font-semibold text-balance w-full bg-lightBlue p-2 rounded">Allergies : {medications?.[0]?.allergies}</div>}
                </div>
              </div>

              <div className="flex flex-row">
                <div
                  className={`text-xl pt-4 font-semibold w-full `}
                >
                  <div className="cursor-pointer underline" onClick={() => handleNavigationToHistory(patData)}>{patData?.pat_name}</div> 

                  <span className="text-sm font-semibold">
                    {" "}
                    {patData?.pat_acct_nubmer}
                  </span>
                  <div className="text-xs font-semibold ">
                    <span>
                      {patData?.pat_gender} . {patData?.pat_age}
                    </span>
                    <div>
                      DOB: {moment.utc(patData?.pat_dob).format("MM/DD/YYYY")}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* <div className="pt-4">
            <input
              type="text"
              name="rxCode"
              id="rxCode"
              value={rxcode}
              autoFocus={true}
              placeholder="Scan RX"
              onChange={(e) => setRxcode(e.target.value)}
              onKeyDown={(e) => handleScanRX(e)}
              className="border focus:outline-none  w-full focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
            />
          </div> */}
          <div className="flex justify-end w-full"> 
          <button
            onClick={() => {
              setStatMedpassOpen(true);
            }}
            type="button"
            className="mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn focus:outline-none"
          >
            Stat Meds
          </button>
          </div>
          <div className="bg-white mt-3 rounded ">
            <div className="text-xs">
              <div className="flex w-full mb-4 bg-header_bg p-2 rounded">
                <div className="w-1/2 font-semibold text-xl text-white">
                  Drug and Dosage
                </div>
                <div className="w-1/2 font-semibold text-xl text-white">
                  Administered
                  <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                </div>
              </div>
              <ul className=" max-h-80 mt-4 overflow-y-auto   ">
                {medications
                  ? medications.map((item, i) => {
                    return (
                      <li key={Math.random()} className="focus:scroll-auto rounded-xl inline-block text-xs leading-6 text-menu_txt w-full mb-4 border-inherit rounded ">
                        <div
                          className={`flex w-full rounded-xl ${(item?.status === "P" || item?.status === "D") ? 'opacity-40 pointer-events-none' : ''} text-black px-3 pt-2 medicationList ${(item?.status === "A" || item?.status === "P")
                            ? "bg-mediApproved"
                            : item?.status === "S"
                              ? "bg-mediSelfApproved"
                              : item?.status === "N"
                                ? "bg-mediRejected"
                                : (item?.status === "R" || item?.status === "D")
                                  ? "bg-mediRefused"
                                  : ""
                            }`}
                        >
                          <div className="w-1/2 flex-column">
                            <div className="text-base	font-semibold text-black">
                              {item.drg_name} {item?.is_diabetic === 'T' && <span className="bg-slate text-xs	ml-2">Insulin</span>}{item?.is_hypertensive === 'T' && <span className="bg-slate text-xs ml-2	">Blood Pressure</span>}
                            </div>
                            <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative  ">
                              {item.frequency}   <span className="font-bold">Qty/Dose: {item?.dose_qty}</span>  {item?.rxf_org_date && `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`} {item?.rxf_exp_date && `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}
                            </span>
                            <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-1">
                            Last administered: {item.last_admit_date} <span className="font-bold">Qty given: {item?.last_admit_qty}</span>
                            </span>
                            <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-3">
                             {item?.ranges?.join()}  {item?.last_fil_date  && `${'Last filled: ' + moment.utc(item?.last_fil_date).format('MM/DD/YYYY')}`} 
                            </span>

                          </div>
                          <div className="w-1/2 	m-auto">
                            <div className={`h-fit flex items-center text-center rounded m-2 cursor-pointer gap-4`}>
                              {item.kop_date ? <span
                                className={` p-5 rounded-3xl text-sm border-inherit mr-4 bg-slate border relative w-full`}
                              >
                                  {(item.status === 'K' && ((Number(item?.today_admit_qty) >= Number(item?.dly_qty)) || Number(item?.qty_dsp) <= 0 ) )  && ( !item.is_readministration )  ?
                                        <div className="flex justify-between items-center mb-2">
                                          <span className="pr-16">Keep on person</span>
                                          <span className="pr-16"> {moment(item.kop_date).format("MM/DD/YYYY")}</span>
                                          <span>{item?.last_admit_qty}</span>
                                        </div>
                                      :<div>
                                        <div className="grid grid-cols-2 gap-2 text-left">
                                          <span>
                                            <span className="pr-16">Keep on person</span>
                                            <span className="pr-16"> {moment(item.kop_date).format("MM/DD/YYYY")}</span>
                                          </span>
                                          <input
                                            type="number"
                                            min={0}
                                            defaultValue={inputValues[item.rxf_id]}
                                            onBlur={(e) => handleInputChange(e, i, item.rxf_id)}
                                            className={` border focus:outline-none h-11 rounded-2xl pl-2 font-normal w-full text-black text-sm`}
                                          />
                                          <div className="absolute top-2 right-3 cursor-pointer"
                                        onClick={() => {
                                          const row = medications[i];
                                          if (row?.is_readministration) {
                                            const curMedications = medications;
                                            curMedications[i].is_readministration = false;
                                            curMedications[i].kop_date = curMedications[i].ori_kop_date
                                            curMedications[i].kop_end_date = curMedications[i].ori_kop_end_date;
                                            curMedications[i].dose_taken_qty = curMedications[i].ori_dose_taken_qty;
                                            setMedications([...curMedications]);
                                          } else {
                                            row.kop_date = "";
                                            setMedications([...medications]);
                                          }
                                        }}
                                          >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                              <path
                                                fill="#df2316"
                                                d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                                              />
                                            </svg>
                                          </div>
                                   
                                        </div>
                                    {(item.koperror || (!item.is_readministration  && item.qty_dsp !== null  && item.qty_dsp !== 0 && Number(item?.dose_taken_qty) > Number(item?.qty_dsp))) && (
                                      <p className="text-xs md:text-sm md:pt-1 text-hlred table error">
                                        You are administering more than the dose
                                      </p>
                                    )}
                                      {(Number(item?.dose_taken_qty) <= 0 ) && (
                                      <p className="text-xs md:text-sm md:pt-1 text-hlred table error">
                                         Please enter a number greater than  zero
                                      </p>
                                    )}
                                        </div>
                                    }
                              </span> :
                                <span
                                  onClick={() => {
                                    const row = medications[i];
                                    row.kop_date = moment(date).format("MM/DD/YYYY");
                                    row.kop_end_date = '';
                                    row.dose_taken_qty = Number(inputValues[item.rxf_id]);
                                    setMedications([...medications]);
                                    setDisableSubmit(false);
                                    doKOPQtyValidation(row?.fil_id,inputValues[item.rxf_id], i)
                                  }}
                                  className={` py-2 px-4 rounded-3xl  text-sm border-inherit  mr-4    border`}
                                >
                                  <span className="pr-16">Keep on person</span>
                                </span>
                              }
                              <button
                                onClick={() => {
                                  CheckReAdministerStatus(item.administration_id, i);
                                }}
                                disabled={item?.is_readministration}
                                type="button"
                                className={`${item.is_readministration ? "opacity-50 cursor-not-allowed" : ""} ${item.status === 'K' && item.kop_date && ((Number(item?.today_admit_qty) >= Number(item?.dly_qty)) || Number(item?.qty_dsp) <= 0)  ? "visible" : "invisible"} ml-auto rounded font-medium h-10 text-white w-40 px-4 bg-secondary bg-login_btn focus:outline-none `}
                              >
                                Re Administer
                              </button>

                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })
                  : null}
              </ul>
            </div>
          </div>
          <div className="bg-white mt-3 rounded w-full">
            <div className="text-xs medicationSection bg-blue-100  rounded-xl p-2 w-full mr-2">
              <div className="flex w-full mb-4 bg-blue p-2 rounded-lg">
                <div className="w-full font-semibold text-lg text-white">
                 STAT / Single Dose Meds Given Today
                </div>
              </div>
              <ul className="max-h-80  mt-4 overflow-y-auto  ">
                {(activeStatMeds && activeStatMeds?.length >0)
                  ? activeStatMeds.map((item, i) => {
                    return (
                      <li key={Math.random()} className="focus:scroll-auto rounded-xl inline-block text-xs leading-6 text-menu_txt w-full mb-4 border-inherit medicationList relative">
                        <div className="absolute top-1 right-3 cursor-pointer"
                          onClick={() => {
                            handleDeleteMedsGivenToday(item?.id, item?.pat_id);
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512">
                            <path
                              fill="#df2316"
                              d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                            />
                          </svg>
                        </div>                       
                       <div
                          className={`flex w-full rounded-xl ${(item?.status === "P"|| item?.status === "D") ? 'opacity-40 pointer-events-none' : ''} text-black px-3 pt-2  ${(item?.status === "P")
                            ? "bg-mediApproved"
                            : item?.status === "S"
                              ? "bg-mediSelfApproved"
                            : item?.status === "N"
                              ? "bg-mediRejected"
                              : (item?.status === "R" || item?.status === "D")
                                ? "bg-mediRefused"
                                  : ""
                            }`}
                        >
                          <div className="w-1/2 flex-column">
                            <div className="text-base	font-semibold text-black">
                              {item.drg_name} {item?.is_diabetic === 'T' && <span className="bg-slate text-xs	ml-2">Insulin</span>}{item?.is_hypertensive === 'T' && <span className="bg-slate text-xs ml-2	">Blood Pressure</span>}
                              {item?.is_prn === 'T' && <span className="bg-slate text-xs ml-2	">PRN</span>}
                              {item?.is_crush === 'T' && <span className="bg-orange text-xs ml-2	">CRUSH</span>}
                            </div>
                            {item?.status === 'I' &&   <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item.rxf_sig} {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`}  {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}
                            </span>}
                            {item?.is_diabetic === 'T' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative ">
                              {item?.rxf_expanded_sig}
                            </span>}
                            {item?.status !== 'I' &&  <span className="font-xxs font-semibold text-black w-full inline-block leading-3 relative">
                              {item?.is_diabetic !== 'T' && item.frequency}   {item?.is_diabetic !== 'T' &&<span className="font-bold">Qty/Dose: {item?.dose_taken_qty}</span>} {item?.rxf_org_date &&  `${'Start date: ' + moment.utc(item?.rxf_org_date).format('MM/DD/YYYY')}`}  {item?.rxf_exp_date &&  `${'Exp date: ' + moment.utc(item?.rxf_exp_date).format('MM/DD/YYYY')}`}  
                            </span>}
                            { <span className="font-xxs font-semibold  text-black w-full inline-block leading-3 relative bottom-1">
                           { item.last_admit_date && <span>Last administered: {item.last_admit_date} </span>} {item?.is_kop === 'T' && <span className="font-bold">Qty given: {item?.last_admit_qty}</span>}
                            </span>}
                           
                          </div>
                        </div>
                        { item?.status === 'I' &&<div className="text-sm  px-3 pb-3 text-grey_color">* This order is not reviewed by the Pharmacist</div>}
                      </li>
                    );
                  })
                  : <div className="flex justify-center text-base">No records found</div>}
              </ul>
            </div>
          </div>
          <div className="flex justify-between	">
            <div className="flex justify-start">
            </div>
            {!(moment(date).isAfter(new Date())) && <div className="flex justify-end">

              <button
                onClick={onCloseMedicationModal}
                type="button"
                className="rounded font-medium h-10 mr-4 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setDisableSubmit(true);
                  setTimeout(() => handleMedicationSubmit(), 2000);
                }}
                type="button"
                className={
                  disableSubmit
                    ? "opacity-50 cursor-not-allowed pointer-events-none mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                    : "mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                }              >
                Submit
              </button>

            </div>}
          </div>
          <div className="text-sm text-grey_color">* This order is not reviewed by the Pharmacist</div>
        </div>
      </Modal>
      <div className="bg-white w-11/12 mx-auto mt-6 mb-4 rounded shadow-md ">
      <div className="tableHeader flex clearboth shadow-md py-8 pl-3 relative">
          <div className="w-1/4 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">KOP ADMINISTRATION</span>
          </div>
          <>
              <span className="absolute right-20 w-2/5">
                <Multiselect
                  name="patient"
                  displayValue="pat_name"
                  options={patients}
                  ref={multiselectRef}
                  closeOnSelect={true}
                  placeholder="Select Patient"
                  selectedValues={patData?.pat_id ? [patData] : []}
                  onSelect={(selectedItem) => {
                    setPatData(selectedItem[0]);
                    getMedications(selectedItem[0]?.pat_id);
                  }}
                  onRemove={(e) => {
                    setPatData({});
                  }}
                  onSearch={(e) => {
                    setSearchValue(e);
                  }}
                  selectionLimit={1}
                />
              </span>
          </>
        </div>
        <div className="p-2 text-xs  w-full grid grid-cols-3 gap-y-4 gap-x-1">
          <div
            className={`inline-block customtop absolute   z-50 ${loading ? "show" : "hidden"
              }`}
          >
            <Loader
              type="Oval"
              color="#00BFFF"
              height={50}
              width={50}
              timeout={300000} //3 secs
            />
          </div>          
        </div>
        {patients?.length === 0 && (
          <div className="w-full flex justify-center">
            {" "}
            <img alt="" className="" src={NO_PATIENTS} />{" "}
          </div>
        )}

      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(KOPAdministration)
);